import { ItemsBlock } from '@core/models/block/items-block';
import { TranslatableBlock } from '@core/models/block/translatable.block';
import { Block } from '@core/models/block/block.model';

export class SpecialBlock extends ItemsBlock implements TranslatableBlock {
  private constructor(data: any) {
    super(data);
  }

  static create(data: Partial<Block>): SpecialBlock {
    return new SpecialBlock(data);
  }
}
